"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER = exports.FORM_SEARCH_FORM_ADDRESS_LABEL = exports.FORM_LIVE_SEARCH_MESSAGE = exports.FORM_ADDRESS_UNAVAILABLE_MESSAGE = exports.EDIT_DELIVERY_ADDRESS_BUTTON_TEXT = exports.DELIVERY_LOCATION_SEARCH_BUTTON_TEXT = exports.APARTMENT_SUIT_INPUT_PLACEHOLDER = exports.APARTMENT_SUIT_INPUT_LABEL = void 0; // Delivery Form Component

var FORM_ADDRESS_UNAVAILABLE_MESSAGE = "Unable to deliver to the address you've provided.";
exports.FORM_ADDRESS_UNAVAILABLE_MESSAGE = FORM_ADDRESS_UNAVAILABLE_MESSAGE;
var FORM_LIVE_SEARCH_MESSAGE = "Searching...";
exports.FORM_LIVE_SEARCH_MESSAGE = FORM_LIVE_SEARCH_MESSAGE;
var FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER = "Enter Your Address";
exports.FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER = FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER;
var FORM_SEARCH_FORM_ADDRESS_LABEL = "Where's your food going?";
exports.FORM_SEARCH_FORM_ADDRESS_LABEL = FORM_SEARCH_FORM_ADDRESS_LABEL;
var APARTMENT_SUIT_INPUT_LABEL = "Apt/Suite";
exports.APARTMENT_SUIT_INPUT_LABEL = APARTMENT_SUIT_INPUT_LABEL;
var APARTMENT_SUIT_INPUT_PLACEHOLDER = "Optional";
exports.APARTMENT_SUIT_INPUT_PLACEHOLDER = APARTMENT_SUIT_INPUT_PLACEHOLDER;
var DELIVERY_LOCATION_SEARCH_BUTTON_TEXT = "Search";
exports.DELIVERY_LOCATION_SEARCH_BUTTON_TEXT = DELIVERY_LOCATION_SEARCH_BUTTON_TEXT;
var EDIT_DELIVERY_ADDRESS_BUTTON_TEXT = "Edit";
exports.EDIT_DELIVERY_ADDRESS_BUTTON_TEXT = EDIT_DELIVERY_ADDRESS_BUTTON_TEXT;
var _default = {
  FORM_ADDRESS_UNAVAILABLE_MESSAGE: FORM_ADDRESS_UNAVAILABLE_MESSAGE,
  FORM_LIVE_SEARCH_MESSAGE: FORM_LIVE_SEARCH_MESSAGE,
  FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER: FORM_SEARCH_FORM_ADDRESS_PLACEHOLDER,
  FORM_SEARCH_FORM_ADDRESS_LABEL: FORM_SEARCH_FORM_ADDRESS_LABEL,
  APARTMENT_SUIT_INPUT_LABEL: APARTMENT_SUIT_INPUT_LABEL,
  APARTMENT_SUIT_INPUT_PLACEHOLDER: APARTMENT_SUIT_INPUT_PLACEHOLDER,
  DELIVERY_LOCATION_SEARCH_BUTTON_TEXT: DELIVERY_LOCATION_SEARCH_BUTTON_TEXT,
  EDIT_DELIVERY_ADDRESS_BUTTON_TEXT: EDIT_DELIVERY_ADDRESS_BUTTON_TEXT
};
exports["default"] = _default;